//import isEmpty from "../validation/is-empty";

import {
  SET_CURRENT_USER,
  GET_USERS,
  GET_ADMIN_USERS,
  CLEAR_CURRENT_USER,
  GET_STATS
} from "../actions/types";

const initialState = {
  isAuthenticated: false,
  user: {},
  users: [],
  admins: [],
  stats: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload
      };
    case CLEAR_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: false,
        user: action.payload
      };
    case GET_USERS:
      return {
        ...state,
        users: action.payload
      };
    case GET_ADMIN_USERS:
      return {
        ...state,
        admins: action.payload
      };
    case GET_STATS:
      return {
        ...state,
        stats: action.payload
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js